import {IContactsState} from '../reducers/chatContactsSlice';
import {createSelector} from '@reduxjs/toolkit';

export const selectChatContacts = (state: any): IContactsState => state.chatContacts;

export const chatContactsSelector = createSelector([selectChatContacts], (state: IContactsState) => state.chatContacts);
